// extracted by mini-css-extract-plugin
module.exports = {"Card":"Days_Card__3zQtn","app-card-list":"Days_app-card-list__3qHN1","app-card":"Days_app-card__s3ZS1","cardShow":"Days_cardShow__H0Mrk"};